import { Icon } from 'components';
import * as S from './style';

export function Loading() {
  return (
    <S.Loading>
      <Icon icon="spinner"/>
    </S.Loading>
  );
}
